import { useParams } from 'next/navigation';

export const useOriginalSearchQuery = () => {
  const { searchquery } = useParams() ?? {};

  return typeof searchquery === 'string' ? searchquery.replace(/\+/g, ' ') : '';
};
